// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"234":"44ba9ebc","977":"d3681ab9"}[chunkId] + ".chunk.js";
};